import "./style.scss";
import * as React from "react";
import { Icon, Popover } from "antd";

export interface ColumnTitleProps {
  title: string;
  hoverContent: string | React.ReactNode;
}

export const ColumnTitle = (props: ColumnTitleProps) => (
  <div style={{ display: "inline" }}>
    {props.title}
    <Popover
      arrowPointAtCenter
      placement="topLeft"
      title="Help"
      trigger="hover"
      content={props.hoverContent}
    >
      <Icon type="question-circle" style={{ marginLeft: 6 }} />
    </Popover>
  </div>
);



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Visualizations/AnalyticsBudgetTable/ColumnTitle.tsx